import {
	GET_ADMIN_ANALYTICS,
	FETCH_ADMIN_ANALYTIC,
	ADD_ADMIN_ANALYTIC,
	EDIT_ADMIN_ANALYTIC,
	DELETE_ADMIN_ANALYTIC,
} from "constants/actions";

const initialState = {
	analytics: [],
	pending: false,
};

export default function ActionAnalytics(state = initialState, action) {
	switch (action.type) {
		case GET_ADMIN_ANALYTICS:
			return {
				...state,
				analytics: action.payload,
				pending: false,
			};

		case FETCH_ADMIN_ANALYTIC:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case ADD_ADMIN_ANALYTIC:
		case EDIT_ADMIN_ANALYTIC:
			if (state.analytics && Array.isArray(state.analytics)) {
				const exists = state.analytics.find((a) => a.id === action.payload.id);
				const analytics = exists
					? state.analytics.map((a) => (a.id === action.payload.id ? action.payload : a))
					: [...state.analytics, action.payload];

				return {
					...state,
					analytics,
					[action.payload.id]: action.payload,
					pending: false,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case DELETE_ADMIN_ANALYTIC:
			return {
				...state,
				analytics: (state.analytics || []).filter((row) => row.id !== action.payload),
				pending: false,
			};

		default:
			return state;
	}
}

